import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadPersonalization, savePersonalization } from "./actions";
import { getPersonalizationByKey, isPersonalizationDataLoaded } from "./selectors";

export const useLoadPersonalization = <T = any>(key: string, initData: any = null) => {
    const dispatch = useDispatch();
    const isDataPreloaded = initData !== null && initData !== undefined;
    const [data, setData] = useState<T>(initData);
    const [isLoaded, setIsLoaded] = useState(isDataPreloaded);

    useEffect(() => {
        let isUnmounted = false;

        if (!isDataPreloaded) {
            dispatch(
                loadPersonalization({
                    key,
                    onComplete: ({ data }) => {
                        if (!isUnmounted) {
                            setData(data);
                            setIsLoaded(true);
                        }
                    },
                })
            );
        }

        return () => {
            isUnmounted = true;
        };
    }, []);

    return [data, isLoaded] as const;
};

export const useSavePersonalization = <T = any>(key: string) => {
    const dispatch = useDispatch();
    return useCallback((data: T) => {
        return dispatch(savePersonalization({ key, data }));
    }, []);
};

export const usePersonalization = <TData = any>(key: string) => {
    const data = useSelector<PersonalizationRootState, TData>(getPersonalizationByKey(key));
    const isLoaded = useSelector(isPersonalizationDataLoaded(key));

    return [data, isLoaded] as const;
};
